import { useRouter } from '@gef-ui/router-core';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../utils';
import SidebarMenuItem from '../SidebarMenuItem';
const COMPONENT_NAME = 'SidebarSubmenuItem';
const SidebarSubmenuItem = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { pathname } = useRouter().useLocation();
    return /*#__PURE__*/ React.createElement(SidebarMenuItem, {
        subItem: true,
        activeProp: "activeSub",
        icon: /*#__PURE__*/ React.createElement(Box, {
            component: "span",
            sx: [
                (theme)=>({
                        width: 4,
                        height: 4,
                        borderRadius: '50%',
                        bgcolor: 'text.disabled',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter
                        })
                    }),
                (pathname === props.to || pathname === props.href) && ((theme)=>({
                        transform: 'scale(2)',
                        bgcolor: theme.palette.primary.main
                    }))
            ]
        }),
        ...props
    });
};
SidebarSubmenuItem.propTypes = {
    href: PropTypes.string,
    to: PropTypes.string
};
export default SidebarSubmenuItem;
